import ArrowDown from '@assets/icons/arrow-down.svg'
import WorldIcon from '@assets/icons/world-icon.svg'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import i18n from '@/locale/i18n'
import { AVAILABLE_LANGUAGES } from '@/types/language'

interface LanguageSwitcherProps {
  disabled?: boolean
  className?: string
}

export const LanguageSwitcher = ({ disabled = false, className }: LanguageSwitcherProps) => {
  const [language, setLanguage] = useState<AVAILABLE_LANGUAGES>(() => i18n.language as AVAILABLE_LANGUAGES)
  const [showSelector, setShowSelector] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    i18n.on('languageChanged', (lng) => {
      setLanguage(lng as AVAILABLE_LANGUAGES)
    })
  }, [])

  const handleLanguageChange = async (lng: AVAILABLE_LANGUAGES) => {
    await i18n.changeLanguage(lng)
    setShowSelector((show) => !show)
  }

  return (
    <div className={`relative flex items-center ${disabled ? 'opacity-50' : ''} ${className}`} data-testid="language-switcher">
      <div>
        <button
          type="button"
          disabled={disabled}
          className={`flex items-center gap-2 ${className}`}
          onClick={() => setShowSelector((show) => !show)}
          id="menu-button"
          data-testid="menu-button"
        >
          <img src={WorldIcon} className="h-5" />
          <span className="text-white">{language.split('_')[0].toUpperCase()}</span>
          <img src={ArrowDown} className="h-2" />
        </button>
      </div>

      {showSelector && (
        <div
          className="absolute right-0 top-9 z-20 mt-2 origin-top-right rounded-md bg-gray-background shadow-strong ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
        >
          <div className="py-1" role="none">
            {Object.values(AVAILABLE_LANGUAGES).map((availableLng) => (
              <button
                className={`${availableLng === language ? 'font-bold text-primary' : 'text-gray-700'} block px-4 py-2 text-sm`}
                key={availableLng}
                onClick={() => handleLanguageChange(availableLng)}
                role="menuitem"
              >
                {t(`languages.${availableLng.split('_')[0]}`)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
